import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/app'
import 'firebase/auth'
import Events from '@/Firestore/Events'

import AdminDashboard from '../components/admin-only/AdminDashboard.vue'
import Users from "../components/admin-only/Users"
import Calendar from '../components/calendar/Calendar.vue'
import AddGame from '../components/game-dashboard/AddGame.vue'
import Projects from '../components/game-dashboard/Projects.vue'
import ProjectSurveys from '../components/game-dashboard/ProjectSurveys.vue'
import GameDetailDescription from '../components/game-detail/GameDetail-Description.vue'
import GameDetailAnalysis from '../components/game-detail/GameDetail-Analysis.vue'
import GameDetailTestersPopup from '../components/game-detail/GameDetail-TestersPopup.vue'
import GameDetailTesters from '../components/game-detail/GameDetail-Testers.vue'
import GameDetailRecordings from '../components/game-detail/GameDetail-Recordings.vue'
import GameDetailSurveys from '../components/game-detail/GameDetail-Surveys.vue'
import GameDetail from '../components/game-detail/GameDetail.vue'
import Playtest from '../components/playtest/Playtest.vue'
import PlaytestInfo from '../components/playtest/Playtest-Info.vue'
import PlaytestAudioVisualCheck from '../components/playtest/Playtest-AudioVisualCheck.vue'
import PlaytestMain from '../components/playtest/Playtest-Main.vue'
import Login from '../components/layout/Login.vue'
import PageNotFound from '../components/layout/PageNotFound.vue'
import EditSurvey from '../components/survey-create/EditSurvey.vue'
import CreateSessionBase from "../components/session-create/CreateSessionBase.vue"
import Surveys from '../components/survey-dashboard/Surveys.vue'
import Templates from "../components/survey-dashboard/Templates.vue"
import PlaytesterAttribute from '../components/user-profile/PlayTesterAttribute.vue'
import UserProfile from '../components/user-profile/UserProfile.vue'
import UserProfileComponent from '../components/user-profile/UserProfile-Profile.vue'
import UserContactComponent from '../components/user-profile/UserProfile-Contact.vue'
import UserSecurityComponent from '../components/user-profile/UserProfile-Security.vue'
import UserPreferenceComponent from '../components/user-profile/UserProfile-Preference.vue'
import TestSession from '../components/test-session/TestSession.vue'
import FakeSurveyAnalytics from '../components/fake-frontend/FakeSurveyAnalytics.vue'
import Achievements from '../components/game-dashboard/Achievements.vue'
import Dashboard from '../components/game-dashboard/Dashboard.vue'
import DynamicComponent from '../components/layout/DynamicComponent.vue'
import Discover from '../components/discover-projects/Discover.vue'
import LandingPageTemp from '../../LandingPageTemp/NewLandingPage.vue'
import ForgotPasswordPage from '../components/layout/ForgotPassword.vue'
import TOSPage from '../components/layout/TermsOfService.vue'
import PrivacyPolicyPage from '../components/layout/PrivacyPolicy.vue'
import Blacklist from '../components/admin-only/Blacklist.vue'
import AiModeration from '../components/admin-only/AiModeration.vue'
import AdminProjects from '../components/admin-only/AdminProjects.vue'
import UserSettings from '../components/settings/UserSettings.vue'
import SettingsNotification from '../components/settings/SettingsTabs/Notifications.vue'
import SettingsAccount from '../components/settings/SettingsTabs/Account.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/dashboard',
      name: 'dashboard',
      component: DynamicComponent,
      props: {
        getComponent: () => {
          const userType = window.localStorage.getItem("userType")
            ? parseInt(window.localStorage.getItem("userType"))
            : -1
          if (userType === 2) {
            return AdminDashboard
          } else if (userType === 1) {
            return Projects
          } else {
            return Dashboard
          }
        },
      },
    },
    { path: '/project-surveys', name: 'project-surveys', component: ProjectSurveys },
    { path: '/game-details-tester', name: 'game-details-tester', component: GameDetailTesters },
    { path: '/game-details-tester-popup', name: 'game-details-tester-popup', component: GameDetailTestersPopup },
    { path: '/login', name: 'login', component: Login },
    { path: '/test', name: 'test', component: TestSession },
    { path: '/discover', name: 'discover', component: Discover },
    { path: '/surveys', name: 'surveys', component: Surveys },
    { path: '/edit-:mode/:itemId', name: 'editsurvey', component: EditSurvey, props: true },
    { path: '/createSession', name: 'createSession', component: CreateSessionBase },
    { path: '/calendar', name: 'calendar', component: Calendar },
    { path: '/achievements', name: 'achievements', component: Achievements },
    {
      path: '/playtest',
      name: 'playtest',
      component: Playtest,
      redirect: () => {
        var playtestSectionIndex = parseInt(window.localStorage.getItem("playtestSectionIndex"))
        if (playtestSectionIndex == 0) return '/playtest/info'
        else if (playtestSectionIndex == 1) return '/playtest/audiovisualcheck'
        else if (playtestSectionIndex == 2) return '/playtest/main'
        else if (playtestSectionIndex == 3) return '/playtest/main'
        else {
          window.localStorage.setItem("playtestSectionIndex", 0)
          return '/playtest/info'
        }
      },
      children: [
        { path: 'info', component: PlaytestInfo },
        { path: 'audiovisualcheck', component: PlaytestAudioVisualCheck },
        { path: 'main', component: PlaytestMain },
      ],
    },
    {
      path: '/userprofile',
      name: 'userprofile',
      component: UserProfile,
      redirect: () => {
        var userProfileIndex = parseInt(window.localStorage.getItem("userProfileIndex"))
        if (userProfileIndex == 0) return '/userprofile/profile'
        else if (userProfileIndex == 1) return '/userprofile/contact'
        else if (userProfileIndex == 2) return '/userprofile/security'
        else if (userProfileIndex == 3) return '/userprofile/preference'
        else {
          window.localStorage.setItem("userProfileIndex", 0)
          return '/userprofile/profile'
        }
      },
      children: [
        { path: 'profile', component: UserProfileComponent },
        { path: 'contact', component: UserContactComponent },
        { path: 'security', component: UserSecurityComponent },
        { path: 'preference', component: UserPreferenceComponent },
      ],
    },
    {
      path: '/gamedetail',
      name: 'gamedetail',
      component: GameDetail,
redirect: () => {
  var gameDetailIndex = parseInt(window.localStorage.getItem("gameDetailIndex"))
  if (gameDetailIndex == 0) return '/gamedetail/description'
  else if (gameDetailIndex == 1) return '/gamedetail/testers'      // was surveys
  else if (gameDetailIndex == 2) return '/gamedetail/recordings'   // was testers
  else if (gameDetailIndex == 3) return '/gamedetail/surveys'      // was recordings
  else {
    window.localStorage.setItem("gameDetailIndex", 0)
    return '/gamedetail/description'
  }
},
      children: [
        { path: 'description', component: GameDetailDescription },
        { path: 'analysis', component: GameDetailAnalysis },
        { path: 'testers', component: GameDetailTesters },
        { path: 'recordings', component: GameDetailRecordings },
        { path: 'surveys', component: GameDetailSurveys },
      ],
    },
    { path: '/addgame', name: 'addgame', component: AddGame },
    { path: '/admindashboard', name: 'admindashboard', component: AdminDashboard },
    { path: '/templates', name: 'templates', component: Templates },
    {
        path: '/blacklist',
        name: 'blacklist',
        component: Blacklist,
    },
    { path: '/users', name: 'users', component: Users },
    { path: '/adminprojects', name: 'adminprojects', component: AdminProjects },
    {
        path: '/aimoderation',
        name: 'aimoderation',
        component: AiModeration
    },
    { path: '/', redirect: '/landing' },
    { path: '*', name: 'pageNotFound', component: PageNotFound },
    { path: '/playtesteratt', name: 'playtesteratt', component: PlaytesterAttribute },
    { path: '/backdoor', name: 'fakesurveyanalytics', component: FakeSurveyAnalytics },
    { path: '/landing', name: 'landing', component: LandingPageTemp },
    { path: '/developerinfo', redirect: { path: '/landing', hash: '#developers' } },
    { path: '/playtesterinfo', redirect: { path: '/landing', hash: '#playtesters' } },
    { path: '/forgot-password', name: 'forgot-password', component: ForgotPasswordPage },
    { path: '/terms-of-service', name: 'terms-of-service', component: TOSPage },
    { path: '/privacy-policy', name: 'privacy-policy', component: PrivacyPolicyPage },
    { path: '/settings', name: 'settingsLink', component: UserSettings,
      children:[
        {path: '', redirect: { name: 'notificationsLink' }},    //When user is on settings page, go straight to notification child
        {path: 'notifications', name:'notificationsLink', component: SettingsNotification,},
        {path: 'account', name:'accountLink', component: SettingsAccount,},
      ]
    },
  ],
})

const SESSION_MARK_KEY = 'lastSessionActive'

function alreadyMarked(key) {
  try {
    return window.localStorage.getItem(SESSION_MARK_KEY) === key
  } catch (e) {
    return false
  }
}

function rememberMark(key) {
  try {
    window.localStorage.setItem(SESSION_MARK_KEY, key)
  } catch (e) {
    return
  }
}

function markSessionActive(uid) {
  const today = new Date().toISOString().split('T')[0]
  const key = `${uid}:${today}`
  if (alreadyMarked(key)) return
  rememberMark(key)
  Events.logEvent('auth.session_active', {
    userType: window.localStorage.getItem('userType'),
  })
}

// ✅ Global navigation guard to prevent bypass
router.beforeEach((to, from, next) => {
  const publicPages = [
    '/login',
    '/landing',
    '/forgot-password',
    '/terms-of-service',
    '/privacy-policy',
    '/developerinfo',
    '/playtesterinfo'
  ]
  const authRequired = !publicPages.includes(to.path)

  firebase.auth().onAuthStateChanged(user => {
    if (authRequired && !user) {
      console.warn("🚫 No user logged in, redirecting to /login")
      localStorage.clear()
      return next('/login')
    }
    if (user) markSessionActive(user.uid)
    next()
  })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js